var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { size: "modal-small", "close-strict": true },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-body-scroll",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "loader-circle"
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row are-you-sure-wrapper",
                  class: [_vm.loading ? "opacity-2" : ""]
                },
                [
                  _c("div", { staticClass: "col-md-12 text-center mb-3" }, [
                    _c("img", {
                      attrs: { src: require("../../../assets/img/monster.svg") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 text-center mb-2" }, [
                    _c("p", [
                      _vm._v(
                        '\n            This will return the job to status "Accepted", all tracking information and hours will be removed.\n          '
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("\n            Do you confirm?\n          ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-12 text-center are-you-sure-actions mt-4"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-3" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              on: {
                                click: function($event) {
                                  _vm.$emit("close")
                                }
                              }
                            },
                            [_vm._v("\n              No\n            ")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mt-3" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: { click: _vm.revertToAccepted }
                            },
                            [_vm._v("\n              Yes\n            ")]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68227446", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68227446","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/modals/AreYouSureRevertToAccepted.vue
// module id = null
// module chunks = 